<template>
  <div>
    <div class="list-data">
      <el-carousel
        :interval="10000"
        height="280px"
        arrow="hover"
        :autoplay="true"
      >
        <el-carousel-item v-for="(item, index) in twoListData" :key="index">
          <div class="item">
            <div class="it" v-for="(it, ind) in item" :key="ind">
              <el-progress
                type="circle"
                :stroke-width="8"
                :width="90"
                :percentage="it.value"
                stroke-linecap="butt"
                class="progress1"
              ></el-progress>
              <div class="mt5">{{ it.name }}</div>
            </div>
          </div>
        </el-carousel-item>
      </el-carousel>
    </div>
    <!-- 渐变色 -->
    <svg width="100%" height="0">
      <defs>
        <linearGradient id="write" x1="0%" y1="0%" x2="100%" y2="0%">
          <stop
            offset="0%"
            style="stop-color: #25D353"
            stop-opacity="0.8"
          ></stop>
          <stop
            offset="100%"
            style="stop-color: #A7FE1A"
            stop-opacity="1"
          ></stop>
        </linearGradient>
      </defs>
    </svg>
  </div>
</template>

<script>
export default {
  props: {
    listData: {
      type: Array,
      default: [],
    },
    startColor: {
      //开始颜色
      type: String,
      default: "#25D353",
    },
    endColor: {
      // 结束颜色
      type: String,
      default: "#A7FE1A",
    },
    value: {
      // 中间标题
      type: [String, Number],
      default: 0,
    },
  },
  data() {
    return {
      roundData: "0",
      Round: null,
      twoListData: [],
    };
  },
  mounted() {},
  methods: {
    // 进度条提示字
    // formatText(value) {
    //   return `${value}`;
    // },
  },
  watch: {
    listData(val, oldval) {
      if (val) {
        this.twoListData = [];
        let len = this.listData.length;
        let n = 6;
        let lineNum = len % 6 === 0 ? len / 6 : Math.floor(len / 6 + 1);
        for (let i = 0; i < lineNum; i++) {
          let temp = this.listData.slice(i * n, i * n + n);
          this.twoListData.push(JSON.parse(JSON.stringify(temp)));
        }
        console.log('二维数组组装', this.twoListData);
      }
    },
  },
  computed: {},
};
</script>
<style>
.el-carousel__arrow--right {
  right: -10px;
}
.el-carousel__arrow--left {
  left: -5px;
}
.el-carousel__indicators--horizontal {
  display: none;
}
</style>
<style scoped>
.list-data {
  width: 380px;
  height: 264px;
}
.item {
  width: 380px;
  height: 280px;
  box-sizing: border-box;
  background-image: url("../assets/icon-07.png");
  background-repeat: no-repeat;
  background-position: center;
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  padding: 15px 20px 0px;
}
.it {
  /* height: 100px; */
}
.mt5 {
  margin-top: 5px;
  text-align: center;
  font-size: 14px;
  color: #a2c6f9;
}
.progress1 /deep/ .el-progress-circle__track {
  stroke: #0a1a58;
}
.progress1 /deep/ .el-progress__text {
  font-size: 20px !important;
  color: #fff;
}
.progress1 /deep/ .el-progress__text {
  background-image: -webkit-linear-gradient(bottom, #e2ebff, #6da7ff);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  font-weight: 900;
}
.progress1 /deep/ svg > path:nth-child(2) {
  stroke: url(#write);
}
.progress1 /deep/ .el-progress-circle__track {
  stroke: rgba(251, 221, 151, 0.2);
}
</style>



// WEBPACK FOOTER //
// src/components/circular-progress-bar.vue